'use strict';

const translateCountry = require('../../../custom_components/js/country-translator');

window.ADDRESS_SELECTED_EVENT = 'address_selected';

module.exports = /* @ngInject */ function() {
    return {
        restrict: 'E',
        scope: {
            /**
             * Currently only "SHIPPING" is supported. "INVOICE" will be implemented later
             */
            addressType: '@',
            /**
             * Document the candidates are selected for: "BASKET" (default) or "RFQ" (EPROC-10910).
             * Drives which site-aware candidate endpoint is queried.
             */
            documentContext: '@',
            /**
             * RFQ request basket id (VS_INDEX); required when documentContext is "RFQ".
             */
            rfqBasketId: '@',
            /**
             * Legacy basket id (VS_INDEX = session id) for documentContext "BASKET"; lets the endpoint
             * read the positions' site codes from VS_BASKETITEMS so the site restriction applies in the
             * legacy cart too (EPROC-10910).
             */
            basketId: '@',
        },
        templateUrl: `./${BUILD_PATH}/address-selection.directive.html`,
        controller: /* @ngInject */ function ($scope, $element, addressService, userService) {

            const SHIPPING_TYPE = 'SHIPPING';

            let addresses;
            $scope.filteredAddresses = null;
            $scope.fullListLength = null;
            $scope.searchQuery = '';
            // Id of the single candidate to pre-select (EPROC-10910); null unless the union has exactly one entry.
            $scope.autoSelectId = null;
            $scope.filter = filter;

            $scope.selectAddress = selectAddress;

            init();

            async function init(){
                $scope.user = await userService.getMyself.get().$promise
                if($scope.addressType === SHIPPING_TYPE) {
                    addressService.getShippingCandidates($scope.documentContext, $scope.rfqBasketId, $scope.basketId).then((result) => {
                        addresses = result.addresses;
                        $scope.autoSelectId = result.autoSelectId;
                        $scope.fullListLength = addresses.length;
                        filter();
                    })
                }
            }

            function filter(query = '') {
                $scope.filteredAddresses = addresses.filter((address) => doesAddressMatch(address, query.toLowerCase()));
                $scope.$apply();
            }

            function selectAddress(address){
                $element.get(0).dispatchEvent(new CustomEvent(ADDRESS_SELECTED_EVENT, {detail: address}));
            }

            function doesAddressMatch(address, query) {
                return getOrDefault(address?.companyAddressWithContact?.companyAddress.companyName?.line1, '').includes(query) ||
                    getOrDefault(address?.companyAddressWithContact?.companyAddress.companyName?.line2, '').includes(query) ||
                    getOrDefault(address?.companyAddressWithContact?.companyAddress.address?.street, '').includes(query) ||
                    getOrDefault(address?.companyAddressWithContact?.companyAddress.address?.zip, '').includes(query) ||
                    getOrDefault(address?.companyAddressWithContact?.companyAddress.address?.city, '').includes(query) ||
                    getOrDefault(address?.companyAddressWithContact?.companyAddress.address?.state, '').includes(query) ||
                    getOrDefault(address?.companyAddressWithContact?.companyAddress.emailAddress?.value, '').includes(query) ||
                    getOrDefault(address?.companyAddressWithContact?.companyAddress.emailAddress?.value, '').includes(query) ||
                    getOrDefault(`${address?.companyAddressWithContact?.personName.firstname} ${address?.companyAddressWithContact?.personName.lastname}`, '').includes(query) ||
                    getOrDefault(`${address?.companyAddressWithContact?.personName.lastname}, ${address?.companyAddressWithContact?.personName.firstname}`, '').includes(query) ||
                    translateCountry(address?.companyAddressWithContact?.companyAddress.address?.country, $scope.user.language.iso639LanguageAlpha2).includes(query)
            }

            function getOrDefault(property, defaultValue) {
                return property ? property.toLowerCase() : defaultValue.toLowerCase();
            }

        }
    };
};
